import '../assets/NcRadioGroup-DQde-Yd1.css';
import Vue, { defineComponent, ref, provide, computed } from "vue";
import { N as NcFormBox } from "./NcFormBox-Bd7m8ffs.mjs";
import { N as NcFormGroup } from "./NcFormGroup-tW-MwPUj.mjs";
import { I as INSIDE_RADIO_GROUP_KEY } from "./useNcRadioGroup-D6llQmAl.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const __default__ = {
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  }
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  __name: "NcRadioGroup",
  props: {
    label: null,
    labelHidden: { type: Boolean },
    hideLabel: { type: Boolean },
    description: null,
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const buttonVariant = ref();
    provide(INSIDE_RADIO_GROUP_KEY, computed(() => ({
      modelValue: props.modelValue,
      onUpdate,
      register
    })));
    function register(isButton) {
      if (buttonVariant.value !== void 0 && buttonVariant.value !== isButton) {
        Vue.util.warn("[NcRadioGroup] Mixing NcCheckboxRadioSwitch and NcRadioGroupButton is not possible!");
      }
      buttonVariant.value = isButton;
    }
    function onUpdate(value) {
      emit("update:modelValue", value);
    }
    return { __sfc: true, props, emit, buttonVariant, register, onUpdate, NcFormBox, NcFormGroup };
  }
});
const radioGroup_checkboxRadioContainer = "_radioGroup_checkboxRadioContainer_amoAo";
const style0 = {
  "material-design-icon": "_material-design-icon_hB6fD",
  radioGroup_checkboxRadioContainer
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.NcFormGroup, { attrs: { "label": _vm.label, "description": _vm.description, "hide-label": _vm.labelHidden || _vm.hideLabel } }, [_setup.buttonVariant ? _c(_setup.NcFormBox, { attrs: { "row": "" } }, [_vm._t("default")], 2) : _c("span", { class: _vm.$style.radioGroup_checkboxRadioContainer }, [_vm._t("default")], 2)], 1);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcRadioGroup = __component__.exports;
export {
  NcRadioGroup as N
};
//# sourceMappingURL=NcRadioGroup-D4kc6Jjr.mjs.map
